import type { CSSProperties } from 'react';

/** @graph-connects none */
const SKELETON_ROW_COUNT = 6;

/**
 * @graph-stack cortex-admin
 * @graph-domain Engineering
 * @graph-business パイプライン一覧のスケルトン。6行のガラススケルトンカードにジョブ名・タイプバッジ・ステータスバッジ・cron式をスタガーアニメーションで表示
 * @graph-connects none
 */
export function PipelineSkeleton() {
  return (
    <div className="space-y-3 animate-fade-in">
      {Array.from({ length: SKELETON_ROW_COUNT }).map((_, i) => (
        <div
          key={i}
          className="glass-card p-4 stagger-item"
          style={{ '--stagger-index': i } as CSSProperties}
        >
          <div className="flex items-center gap-4">
            {/* ジョブ名スケルトン */}
            <div className="flex-1 min-w-0">
              <div className="skeleton-glass h-5 w-3/5 rounded mb-2" />
              <div className="skeleton-glass h-3 w-2/5 rounded" />
            </div>

            {/* タイプバッジスケルトン */}
            <div className="hidden sm:block">
              <div className="skeleton-glass h-6 w-20 rounded-full" />
            </div>

            {/* ステータスバッジスケルトン */}
            <div className="hidden sm:block">
              <div className="skeleton-glass h-6 w-16 rounded-full" />
            </div>

            {/* Cron式スケルトン */}
            <div className="hidden md:block">
              <div className="skeleton-glass h-4 w-24 rounded" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
